import {
  SignupRequestSchema,
  SignupResponseSchema,
  type SignupRequest,
  type SignupResponse,
} from '@crv/contracts/auth';

import { apiPost } from './http-client';

export async function signup(input: SignupRequest): Promise<SignupResponse> {
  const payload = SignupRequestSchema.parse(input);
  return apiPost('/v1/auth/signup', SignupResponseSchema, payload);
}

